import { Mail, Heart, Info } from 'lucide-react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* 关于 */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <Info className="w-4 h-4 text-theme-500" />
              关于
            </h3>
            <p className="text-sm text-slate-600">
              免费转盘小工具
            </p>
          </div>

          {/* 链接 */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900 mb-3">链接</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/guide"
                  className="text-slate-600 hover:text-theme-500 transition-colors"
                >
                  <p className="font-medium text-slate-700">使用说明</p>
                  {/* <p className="mt-1 text-xs text-slate-500">
                    从配置选项到保存与导入，完整了解使用转盘的最佳实践。
                  </p> */}
                </Link>
              </li>
              {/* <li>
                <a href="#" className="text-slate-600 hover:text-theme-500 transition-colors">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-theme-500 transition-colors">
                  反馈建议
                </a>
              </li> */}
            </ul>
          </div>

          {/* 联系 */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900 mb-3">联系</h3>
            <div className="flex items-center gap-3">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-600 hover:text-theme-500 transition-colors"
                title="GitHub"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="mt-6 pt-6 border-t border-slate-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-slate-500">
            <p>
              © {new Date().getFullYear()} PickRightNow. All rights reserved.
            </p>
            <p className="flex items-center gap-1">
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">粤ICP备2025503719号-1</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

